
<template>
  <a-card :bordered="false">
    <component @onLook="handleLook" @onEdit="handleEdit" @onGoBack="handleGoBack" :record="record" :is="currentComponet"></component>
  </a-card>
</template>

<script>

import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
// 动态切换组件
import List from '@/views/a-inout/table/List'
import Edit from '@/views/a-inout/table/Edit'
import Look from '@/views/a-inout/table/Look'

export default {
  name: 'InOut',
  components: {
    AInput,
    ATextarea,
    List,
    Edit,
    Look
  },
  data () {
    return {
      currentComponet: 'List',
      record: ''
    }
  },
  created () {

  },
  methods: {
    handleLook (record) {
      this.record = record || ''
      this.currentComponet = 'Look'
      console.log(record)
    },
    handleEdit (record) {
      this.record = record || ''
      this.currentComponet = 'Edit'
      console.log(record)
    },
    handleGoBack () {
      this.record = ''
      this.currentComponet = 'List'
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
